
























import { Vue, Component, Prop } from "vue-property-decorator";

import DropdownMenu from "@share/common/drop-down/DropdownMenu.vue";
import KebabIcon from "@share/common/icons/KebabIcon.vue";
import { DropDownItem } from "../drop-down/types";

import { createPopper, Instance as PopperInstance, Modifier, OptionsGeneric } from "@popperjs/core";

@Component({ components: { DropdownMenu, KebabIcon } })

export default class KebabMenu extends Vue {
    @Prop({ default: []} ) items: DropDownItem[];
    @Prop({ default: true }) needCloseAfterSelect: boolean;

    showDropdown = false;
    popper: PopperInstance | null = null;

    choose(item: DropDownItem) {
        this.$emit('choose', item.id)
    }

    toggleMenu() {
        this.showDropdown = !this.showDropdown

        if(this.showDropdown) {
            this.$nextTick(this.createPopper);
        }
        else {
            this.destroyPopper();
        }
    }

    createPopper() {
        const el = this.$el as HTMLElement;

        const $button = el.getElementsByTagName('button').item(0);
        const $menu = el.getElementsByTagName('ul').item(0);

        if($button && $menu) {

            const options: Partial<OptionsGeneric<Partial<Modifier<"offset" | "arrow", any>>>> = {
                placement: "bottom-end",
                modifiers: [
                    {
                        name: "offset",
                        options: {
                            offset: [11, 10]
                        }
                    },
                    {
                        name: 'arrow',
                        options: {
                            padding: 8,
                        },
                    },
                ]
            }

            this.popper = createPopper(
                $button,
                $menu,
                options
            )
        }
    }

    destroyPopper() {
        this.popper?.destroy();
        this.popper = null;
    }
}

